import * as Yup from 'yup'
import { useStoreState } from '@mortgage-pos/ui/store'
import React, { useCallback, useMemo } from 'react'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'
import { prepareDataForValidation, yupToFormErrors } from 'formik'
import { useVariation } from '@mortgage-pos/ui/services/featureFlags'
import {
  buildInitialValues,
  generateDynamicYupSchema,
} from '@mortgage-pos/ui/utils/pageHelpers'

export function useInitialValues(questions) {
  const { mergedAnswers } = useStoreState((state) => state.answers)

  const initialValues = useMemo(
    () => buildInitialValues(questions, mergedAnswers),
    [questions, mergedAnswers]
  )

  return initialValues
}

export function useValidate(questions) {
  const { mergedAnswers } = useStoreState((state) => state.answers)
  const prebuiltValidations = useStoreState(
    (state) => state.visibleIfConditions
  )

  const validate = useCallback(
    (values) => {
      const allAnswers = { ...mergedAnswers, ...values }

      const schema = Yup.lazy(() => {
        return generateDynamicYupSchema(
          questions,
          allAnswers,
          prebuiltValidations
        )
      })

      const preparedValues = prepareDataForValidation(values)

      return schema
        .validate(preparedValues, { abortEarly: false, context: allAnswers })
        .then(() => {})
        .catch((err) => {
          return yupToFormErrors(err)
        })
    },
    [mergedAnswers, questions]
  )

  return validate
}
